<template>
  <div>
       <b-form-group label="Job Name:" label-cols="2" label-align="right">
      <b-form-input
        id="jobName"
        class="form-control"
        type="text"
        v-model="value.name"
        placeholder="New Job"
        trim
        @input="input"
        @change="change"
        @keypress.enter="done"
      />
    </b-form-group>

    <b-form-group label="Output quality:" label-cols="2" label-align="right">
      <b-form-select
        id="jobQuality"
        v-model="value.options.quality"
        :options="quality_opts"
        @input="input"
        @change="change"
      />
    </b-form-group>
  </div>
</template>

<script>
import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.FormGroupPlugin,
    bs.FormSelectPlugin,
    bs.FormInputPlugin,
].forEach(p=> Vue.use(p))

const quality_opts = [
  {value:'low', text: "Low - for Mobile Web"},
  {value:'medium', text: "Medium - for 3D Printing"},
  {value:'high', text: "Best - for Close Up and VR"}
];

export default {
  props: ["value"],
  data(){return {quality_opts}},
  methods: {
      input() {
        this.$emit('input', this.value);
      },
    change() {
      this.$emit('change', this.value);
    },
    done(){
        this.$emit('done', this.value);
    }
  }
};
</script>